import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ArrowDownIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "arrow-down",
  "ArrowDownIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M11.3335 9.33333L8.00016 14L4.66683 9.33333L7.3335 9.33333L7.3335 2L8.66683 2L8.66683 9.33333L11.3335 9.33333Z" fill={colorList[0]}/></g></svg>
);

export default ArrowDownIcon;
